import React from "react";

const version: string =
  process.env.REACT_APP_VERSION ?? require("../../package.json").version;

const stagePrefixes: Partial<Record<string, string>> = {
  development: "dev",
  test: "test",
};

const getLabel = (env: string | undefined): string => {
  const prefix = env ? stagePrefixes[env] : undefined;
  return prefix ? `${prefix}.${version}` : `v${version}`;
};

export const VersionBadge: React.FC = () => (
  <span className="inline-flex items-center justify-center bg-primary text-white text-xs font-medium px-2 py-2 rounded-lg leading-none">
    {getLabel(process.env.REACT_APP_ENV ?? process.env.NODE_ENV)}
  </span>
);
